import { useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { fmtData } from "@/lib/helpers";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export function EditingFields({ form, onChange }) {
  return <fieldset className="rounded-xl border border-[#27272A] p-3 space-y-3">
    <legend className="px-1 text-sm font-semibold">Planejamento da edição</legend>
    <div><Label htmlFor="videos-mes">Vídeos para editar por mês</Label><Input id="videos-mes" type="number" min="0" max="1000" value={form.videos_mes || 0} onChange={e => onChange("videos_mes", Number(e.target.value))} /></div>
    <div><Label htmlFor="dias-edicao">Dias de edição por ciclo</Label><select id="dias-edicao" className="w-full rounded-lg border border-[#27272A] bg-[#18181C] p-3" value={form.dias_edicao || "auto"} onChange={e => onChange("dias_edicao", e.target.value === "auto" ? null : Number(e.target.value))}>
      <option value="auto">Automático — 8 vídeos: 2 dias</option><option value="1">1 dia</option><option value="2">2 dias consecutivos</option>
    </select></div>
    <p className="text-sm text-[#A1A1AA]">Dois dias: edição 1 → edição 2 no dia seguinte → envio para aprovação um dia depois. São dias corridos. Vale para novos ciclos recorrentes; ciclos em andamento podem ser ajustados na prévia.</p>
  </fieldset>;
}

export function EditingSchedule({ ciclo, onChanged }) {
  const [plan, setPlan] = useState(null);
  const [busy, setBusy] = useState(false);
  const [reschedule, setReschedule] = useState(false);
  const base = `/ciclos/${ciclo.id}/edicao-dois-dias`;
  async function preview() {
    setBusy(true);
    try { setPlan((await api.get(base)).data); setReschedule(false); }
    catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); }
  }
  async function apply() {
    setBusy(true);
    try { await api.post(base, { chave: plan.chave, reagendar_aprovacao: reschedule }); setPlan(null); onChanged(); toast.success("Edição organizada em dois dias"); }
    catch (err) { toast.error(apiError(err)); onChanged(); }
    finally { setBusy(false); }
  }
  return <>
    <Button variant="outline" disabled={busy} onClick={preview} className="my-3">Organizar edição em dois dias</Button>
    <Dialog open={!!plan} onOpenChange={open => { if (!open && !busy) setPlan(null); }}>
      <DialogContent className="bg-[#141418] border-[#27272A] text-[#F4F4F0] max-h-[90dvh] overflow-y-auto">
        <DialogHeader><DialogTitle>Dois dias de edição · {ciclo.competencia}</DialogTitle><DialogDescription>Esta prévia ajusta somente este ciclo. A data do dia 1, tarefas concluídas e demais etapas são preservadas.</DialogDescription></DialogHeader>
        {plan && <div className="space-y-4">
          <p>Edição dia 1: <strong>{plan.dia1 ? fmtData(plan.dia1) : "A agendar"}</strong></p><p>Nova tarefa · edição dia 2: <strong>{plan.dia2 ? fmtData(plan.dia2) : "A agendar"}</strong></p>
          <p>Envio para aprovação atual: <strong>{fmtData(plan.aprovacao_atual) || "Sem data"}</strong></p>
          {plan.aprovacao_manual ? <p className="text-sm text-[#F59E0B]">A aprovação tem uma data ajustada manualmente e será preservada. Você pode editar essa tarefa depois.</p> : plan.sem_data ? <p className="text-sm text-[#A1A1AA]">Os dois dias ficam a agendar. Ao definir a data do dia 1, o dia 2 será no dia seguinte e o envio para aprovação no próximo dia. Datas ajustadas manualmente serão preservadas.</p> : <label className="flex gap-3 items-start text-sm"><input type="checkbox" className="mt-1" checked={reschedule} onChange={e => setReschedule(e.target.checked)} />Reagendar envio para aprovação para {fmtData(plan.aprovacao)} (dia seguinte à edição 2).</label>}
          <Button className="w-full" disabled={busy} onClick={apply}>{busy ? "Aplicando…" : "Aplicar neste ciclo"}</Button>
        </div>}
      </DialogContent>
    </Dialog>
  </>;
}
